export const NOTE_TYPES = {
  ACCOUNT: 'account',
  LOCATION: 'location',
  CONFIGURED_SERVICE: 'configuredService',
  WORK_ORDER: 'workOrder',
  BILLING: 'billing',
}
